/**
 *
 * @author: Matthew Rawson @ 11/09/2018 14:04
 * @description:
 * @notes:
 */
import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import Loader from "@irati/ui/src/Loading/Loader"
import {greys} from "@irati/ui/src/global/colors"


const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: ${greys.white};
`


const ReactTableLoading = ({loading, ...props}) => {
  const idNamespace = id("ReactTableLoading", props)

  if (!loading) return null

  return (
    <Wrapper {...props} id={idNamespace}>
      <Loader />
    </Wrapper>
  )
}


ReactTableLoading.propTypes = {
  loading: PropTypes.bool
}
ReactTableLoading.defaultProps = {
  loading: false
}

export default ReactTableLoading
